<template>
  <div class="m-3 bg-gray-900 flex items-center justify-between">
    <div class="flex items-center">
      <ChevronRightIcon
        :class="[
          'h-8 w-8 p-2 mr-2 cursor-pointer inline bg-gray-800 rounded-lg transition-transform text-text-primary',
          { 'rotate-90': visible },
        ]"
        @click="$emit('toggleRow', trainingSession.uuid)"
      />

      <div class="flex flex-col w-32 mr-8">
        <span class="text-gray-100 text-sm">
          {{ moment(trainingSession.created_at).calendar(null, {
            sameDay: '[Today]', lastDay: '[Yesterday]', lastWeek: 'MMMM Do, YYYY', sameElse: 'MMMM Do, YYYY',
          }) }}
        </span>
        <span class="text-gray-400 text-xs">
          <span v-if="trainingSession.live">
            {{ $t('training.session_row.since', { time: moment(trainingSession.created_at).format("h:mm A") }) }}
          </span>
          <span v-else>
            {{ moment(trainingSession.created_at).format("h:mm A") }}
            -
            {{ moment(trainingSession.ended_at).format("h:mm A") }}
          </span>
        </span>
      </div>
      <span class="text-text-primary">
        {{ trainingSessionName(trainingSession) }}
      </span>
    </div>
    <Server :trainingSession="trainingSession" />
    <router-link
      :to="`/sessions/${trainingSession.uuid}`"
      class="bold text-sm ml-2 py-2 px-2 text-white flex cursor-pointer items-center justify-center rounded-md bg-primary-600 hover:bg-primary-500 duration-200">
      <ArrowRightIcon class="h-4 w-4" />
    </router-link>
  </div>

  <Transition name="fade" v-show="visible">
    <div class="md:ml-12 ml-2 mr-2">
      <div v-if="trainingSession.activities?.length > 0" v-for="activity in trainingSession.activities">
        <Activity :live="trainingSession.live" :activity="activity" :modCategories="modCategories" :selectedMetric="selectedMetric" />
      </div>
      <div v-else-if="trainingSession.live">
        <div class="px-1 pb-4 text-text-secondary text-xs tracking-[1.5px]">
          {{ $t('training.shared.server_ready_hint') }}
        </div>
      </div>
      <div v-else-if="loaded">
        <div class="text-text-secondary px-1 pb-4 italic text-sm">
          {{ $t('training.session_row.nothing_to_show') }}
        </div>
      </div>
      <div v-else>
        <h2 class="p-6 mr-1 bg-gray-800 rounded-t-lg text-gray-100" />
        <div class="p-6 mr-1 border-t border-gray-900 bg-gray-800" />
        <div class="h-2 rounded-b-lg mb-3 bg-gray-800" />
      </div>
    </div>
  </Transition>
</template>

<script setup>
import moment from 'moment';
import { useRouter } from 'vue-router';
import { ChevronRightIcon } from '@heroicons/vue/24/outline';
import { ArrowRightIcon } from '@heroicons/vue/24/solid';

import Activity from './Activity.vue';
import Server from './Server.vue';
import { trainingSessionName } from '../../utils/training_session.js';

const router = useRouter();

const props = defineProps({
  trainingSession: {
    type: Object,
    required: true,
  },
  visible: {
    type: Boolean,
    required: true,
  },
  loaded: {
    type: Boolean,
    required: true,
  },
  modCategories: {
    type: Array,
    required: true,
  },
  selectedMetric: {
    type: Object,
    required: false,
  },
});

defineEmits(['toggleRow']);

</script>

<style scoped>
.rotate-90 {
  transform: rotate(90deg);
}
</style>
